import React from 'react';

// services
import {ConfigManager} from '../../services/ConfigManager';

// components
import Menu from '../Menu';

// hooks
import {useMenuItems} from '../../hooks';

// styles
import {
  BottomMenuSection,
  BottomMenuSectionContent,
  LenderName,
  Logo,
  MenuSection,
  SideBarContainer,
  TopMenuSection,
  TopSection,
  Divider,
} from './SideBar-styles';

const SideBar = () => {
  // Use the shared hook to get menu items
  const {menuItems, configMenuItems} = useMenuItems();
  const portalConfig = ConfigManager.getConfig();

  return (
    <SideBarContainer>
      <TopSection to="/dashboard">
        {portalConfig?.logo && <Logo url={portalConfig.logo}></Logo>}
        <LenderName>{portalConfig?.lenderName}</LenderName>
      </TopSection>
      <Divider />
      <MenuSection>
        <TopMenuSection>
          <Menu menuItems={menuItems} />
        </TopMenuSection>
        <BottomMenuSection>
          <BottomMenuSectionContent>
            <Divider />
            <Menu menuItems={configMenuItems} />
          </BottomMenuSectionContent>
        </BottomMenuSection>
      </MenuSection>
    </SideBarContainer>
  );
};

export default SideBar;
